import { Helmet } from 'react-helmet-async';
import logo from '../../assets/gpm-logo.png';

/**
 * SeoStructuredData component for injecting structured data 
 * to improve SEO and enhance social sharing
 */
const SeoStructuredData = ({ 
  title = "GPM Tools - Website Performance Analysis",
  description = "Analyze website performance, discover optimization opportunities, and improve SEO scores with Gravity Point Media's Performance Analysis Tool",
  url = window.location.href,
  imageUrl = logo,
  type = "WebApplication"
}) => {

  // Format the data according to Schema.org guidelines
  const structuredData = {
    "@context": "https://schema.org",
    "@type": type,
    "name": title,
    "description": description,
    "url": url,
    "applicationCategory": "WebApplication",
    "operatingSystem": "All",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "provider": {
      "@type": "Organization",
      "name": "Gravity Point Media",
      "logo": {
        "@type": "ImageObject",
        "url": imageUrl
      }
    },
    "screenshot": {
      "@type": "ImageObject",
      "url": imageUrl
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SeoStructuredData;